// shame.js

(function ($) {
  if($('.meta-top .banner-image, .meta-top .mediagallery, .meta-top figure.asset-audio, .meta-top figure.asset-video').length !== 0) {
    //Es gibt ein Bannerbild an der Stelle, die das JSON definiert hat.
    //Bannerbild an falscher Stelle wird entfernt:
    $('.detail > .aquarium-panoramateaser .banner-image, .detail > .aquarium-panoramateaser .mediagallery, .detail > .aquarium-panoramateaser figure.asset-audio, .detail > .aquarium-panoramateaser figure.asset-video').remove();
  }
})(window.jQuery);
